import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class TerritorioService extends BaseService {
  private baseUrl = '/territorio';

  getAll(): Observable<string[]> {
    return this.baseGet<string[]>(`${this.baseUrl}/uf`);
  }
}
